import React, { useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";

const MD = {
  p: (props) => <p className="mb-2 last:mb-0" {...props} />,
  ul: (props) => <ul className="list-disc pl-5 mb-2 space-y-1" {...props} />,
  ol: (props) => <ol className="list-decimal pl-5 mb-2 space-y-1" {...props} />,
  h1: (props) => <p className="font-bold mb-2" {...props} />,
  h2: (props) => <p className="font-bold mb-2" {...props} />,
  h3: (props) => <p className="font-semibold mb-1" {...props} />,
  a: (props) => <a className="underline" target="_blank" rel="noopener noreferrer" {...props} />,
  code: (props) => <code className="px-1 rounded bg-background/60 text-xs" {...props} />,
};

export function MessageList({ messages, sending, empty, testId }) {
  const end = useRef(null);
  useEffect(() => {
    end.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages, sending]);
  return (
    <div className="flex-1 overflow-y-auto p-5 space-y-4 sg-scroll" data-testid={testId}>
      {messages.length === 0 && <div className="text-sm text-muted-foreground max-w-md leading-relaxed">{empty}</div>}
      {messages.map((m, i) => (
        <div key={m.id || i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
          <div className={`max-w-[85%] rounded-xl px-4 py-3 text-sm leading-relaxed whitespace-pre-wrap ${
            m.role === "user" ? "bg-indigo-600 text-white" : "bg-muted text-foreground border border-border whitespace-normal"}`}>
            {m.role === "user" ? m.content : <ReactMarkdown components={MD}>{m.content}</ReactMarkdown>}
          </div>
        </div>
      ))}
      {sending && <div className="text-xs text-muted-foreground animate-pulse" data-testid="chat-typing">Thinking…</div>}
      <div ref={end} />
    </div>
  );
}
